/** Build the default SMS/message preview for public intake scheduling */
export function buildIntakeScheduleMessage(
  firstName: string,
  slotIso: string | null,
  timezone: string
): string {
  const name = firstName.trim() || 'there';
  if (!slotIso) {
    return `Hi ${name}, you have been invited to have a video call. Join the meeting by clicking this link:`;
  }

  const date = new Date(slotIso);
  const timeStr = date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZone: timezone,
  });
  const dateStr = date.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: timezone,
  });

  return `Hi ${name}, you have been invited to have a video call at ${timeStr} on ${dateStr}. Join the meeting by clicking this link:`;
}

/** YYYY-MM-DD in a given IANA timezone */
export function dateKeyInTimezone(isoOrDate: string | Date, timeZone: string): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(typeof isoOrDate === 'string' ? new Date(isoOrDate) : isoOrDate);
}
